export default "__VITE_ASSET__Dy2aYmW4__"